var render, staticRenderFns
import script from "./refundgf.vue?vue&type=script&lang=js"
export * from "./refundgf.vue?vue&type=script&lang=js"
import style0 from "./refundgf.vue?vue&type=style&index=0&id=71fa883c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fa883c",
  null
  
)

export default component.exports